export const coachDemographicKeys = {
    all: ['coach-demographics'] as const,
  
    lists: () => [...coachDemographicKeys.all, 'list'] as const,
  
    coachGender: () => [...coachDemographicKeys.lists(), 'coachGender'] as const,
    coachEthnicity: () => [...coachDemographicKeys.lists(), 'coachEthnicity'] as const,
    coachSexualOrientation: () => [...coachDemographicKeys.lists(), 'coachSexualOrientation'] as const,
  
    detail: (id: string) => [...coachDemographicKeys.lists(), id] as const,
  };
  